module.exports = __webpack_public_path__ + "img/milo-weiler-yLArTj2kIMg-unsplash.8c56a08c.jpg";